import { Injectable } from '@angular/core';
import { UserSession } from '../models/user-session';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class SessionUserService {

  private _userSession: UserSession;

  constructor(private tokenService: TokenService) { }

  get userSession(): UserSession {
    return this._userSession ? this._userSession : this.tokenService.getDecodeToken();
  }
  hasAnyPermission(authorities: string[]): boolean {
    let validation = this.userSession.authorities?.filter(authoritie => {
      return authorities.includes(authoritie)
    });
    return validation == undefined ? false : authorities.length == 0 ? false : validation.length == authorities.length;
  }
}
